import { useState } from 'react';
import { TaxReturnListFetchParams, TaxReturnForList } from '../../../interfaces/taxReturn';
import useQueryParamsObject from '../../../hooks/useQueryParamsObject';
import useDeepCompareEffect from '../../../hooks/useDeepCompareEffect';
import globalErrorHandler from '../../../utils/globalErrorHandler';
import { GetPolywizzParams, Polywizz } from '../../../interfaces/Insurance';
import { getPolywizz } from '../../../utils/api/insurance';

const useFetchPolywizz = () => {
    const queryParams = useQueryParamsObject();
    const [loading, setLoading] = useState(false);
    const [polywizzItems, setPolywizzItems] = useState<Polywizz[]>([]);
    const [total, setTotal] = useState(0);

    const fetchPolywizz = async (params: any) => {
        if (!params || Object.keys(params).length === 0) return;

        try {
            setLoading(true);
            const response = await getPolywizz(params);
            const polywizzItems = response.items;
            const total = response.total;

            setPolywizzItems(polywizzItems);
            setTotal(total);
        } catch (error) {
            globalErrorHandler(error);
        } finally {
            setLoading(false);
        }
    };

    useDeepCompareEffect(() => {
        fetchPolywizz(queryParams);
    }, [queryParams]);

    return {
        loading,
        polywizzItems,
        setPolywizzItems,
        total,
    };
};

export default useFetchPolywizz;
